<template>  
  <div class="text-xs-center">
    <div v-for="button in buttons" v-bind:key="button" style="display: flex; justify-content: space-evenly;">
      <v-btn
        v-if="button.type == 'download'"
        :href="button.href"
        @click.native="
          window._paq.push([
            'trackEvent',
            button.name,
            'Click',
            button.url,
          ])
        "
        download
        :color="button.theme"
      >
        <v-icon class="icon">download</v-icon>
        <div class="ml-2">{{ button.name }}</div>
      </v-btn>
      <template v-if="button.type == 'downloadReview'">
        <div class="text-center">
          <v-dialog
            v-model="dialog"
            width="500"
            class="align-center"
          >
            <template v-slot:activator="{ on, attrs }">              
              <v-btn
                :href="button.href"
                @click.native="
                  alert(button)
                  window._paq.push([
                    'trackEvent',
                    button.name,
                    'Click',
                    button.url,
                  ])
                "
                v-bind="attrs"
                v-on="on"
                download
                :color="button.theme"
              >
                <v-icon class="icon">download</v-icon>
                <div class="ml-2">{{ button.name }}</div>
              </v-btn>
            </template>

            <v-card 
            style="height: 300px;">
              <v-card-title class="text-h5 grey lighten-2">
                Download started!
              </v-card-title>

              <v-card-text>
                Your download has started. 
                <br><br>Oh, and it would be <b>awesome</b> if you left a review for the book on Amazon! (not required though)
                <br><br>Here's the review page: <a :href="button.reviewURL">{{button.reviewURL}}</a>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  text
                  @click="dialog = false"
                >
                  Ok!
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </template>
      <v-btn
        v-if="button.type == 'shop'"
        @click.native="
          window._paq.push([
            'trackEvent',
            button.name,
            'Click',
            button.url,
          ]);
          window.setTimeout(function () {
            window.open(button.url, '_blank').focus();
          }, 500);
        "
        :color="button.theme"
      >
        <v-icon class="icon">shopping_cart</v-icon>
        <div class="ml-2">Shop Print and Digital</div>
      </v-btn>
    </div>
  </div>
</template>

<script>

export default {
  name: "MusicButtons",
  props: {
    buttons: Array
  },
  data () {
      return {
        dialog: false,
    }
  },
};
</script>

<style>
.v-dialog {
  height: 300px;
}
</style>